import { defineMessages } from "react-intl";

export const messages = defineMessages({
  buttonLabel: {
    id: "button.createConsentAgreement.label",
    defaultMessage: "Create",
    description: "Create consent agreement button label",
  },
});
